<template>
  <header class="modal-header border-bottom">
    <div class="label-text" v-if="back" @click="backClicked">再検索</div>

    <div class="title">{{ title }}</div>

    <div class="icon-close" @click="closeClicked">
      <img :src="iconClose" alt />
    </div>
  </header>
</template>

<script>
import IconClose from "../assets/icon-close.svg"

export default {
  props: ["back", "title", "label"],

  data() {
    return {
      iconClose: IconClose
    }
  },

  methods: {
    backClicked() {
      this.$emit("backClicked")
    },

    closeClicked() {
      this.$emit("closeClicked")
    }
  }
}
</script>

<style scoped>
.modal-header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  background-color: #fff;
  z-index: 2;
}

.modal-header .icon-close {
  position: absolute;
  right: 4px;
  top: 50%;
  width: 48px;
  height: 48px;
  margin-top: -24px;
  padding: 10px;
}

.modal-header .icon-close img {
  width: 100%;
}

.modal-header .title {
  position: absolute;
  left: 50%;
  width: 240px;
  margin-left: -120px;
  line-height: 44px;
  font-weight: bold;
  text-align: center;
}

.modal-header .label-text {
  color: #f05353;
  padding-left: 20px;
}
</style>
